import React from 'react';

interface PartnersHeroV2Props { isZh: boolean }

const PartnersHeroV2: React.FC<PartnersHeroV2Props> = ({ isZh }) => {
  return (
    <section className="relative w-full overflow-hidden bg-black" style={{ minHeight: '70vh', height: '70vh' }}>
      <img
        src="https://images.pexels.com/photos/1813466/pexels-photo-1813466.jpeg?auto=compress&w=1920"
        alt={isZh ? '合作夥伴' : 'Partners'}
        className="absolute inset-0 w-full h-full object-cover opacity-65"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/30" />
      <div className="relative z-10 max-w-[1600px] mx-auto h-full px-6 lg:px-12 flex items-end pb-16">
        <h1
          className="text-white tracking-wide leading-[0.95]"
          style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(60px, 10vw, 152px)' }}
        >
          {isZh ? '合作夥伴' : 'Partners'}
        </h1>
      </div>
    </section>
  );
};

export default PartnersHeroV2;
